

<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://nfcread.com" target="_blank" rel="nofollow">NFCRead</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center footer-icon">
            <span> Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
            <span> &nbsp; By <a href="http://sanalogi.com" target="_blank"> Sanalogi </a> | 
            <a href="https://www.linkedin.com/showcase/nfcread" target="_blank"> <feather-icon icon="LinkedinIcon" svgClasses=" w-5 h-5" class="ml-2" /> </a>
            <a href="https://www.facebook.com/nfcread" target="_blank"> <feather-icon icon="FacebookIcon" svgClasses=" w-5 h-5" class="ml-2" /> </a>
            <a href="https://www.youtube.com/nfcread" target="_blank"> <feather-icon icon="YoutubeIcon" svgClasses=" w-5 h-5" class="ml-2" /> </a>
             </span>
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    }
}
</script>
